import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const LANGUAGES = [
  "English", "Spanish", "Portuguese", "Haitian Creole", "Mandarin",
  "Cantonese", "Vietnamese", "Arabic", "Russian", "Cape Verdean Creole"
];

const LocationSection = ({ formData, neighborhoods, onChange, onMultiSelect, onArrayInput }) => (
  <Card className="rounded-2xl border-[#E0D6C8]">
    <CardHeader className="pb-4">
      <CardTitle className="text-lg font-['Manrope']">Location & Contact</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label>Neighborhoods Served</Label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2">
          {neighborhoods.map(neighborhood => (
            <div key={neighborhood} className="flex items-center space-x-2">
              <Checkbox id={`neighborhood-${neighborhood}`} data-testid={`neighborhood-${neighborhood}`} checked={formData.neighborhoods_served?.includes(neighborhood)} onCheckedChange={(checked) => onMultiSelect('neighborhoods_served', neighborhood, checked)} />
              <label htmlFor={`neighborhood-${neighborhood}`} className="text-sm text-[#5A5A5A]">{neighborhood}</label>
            </div>
          ))}
        </div>
      </div>
      <div>
        <Label>Zip Codes</Label>
        <Input data-testid="zipcodes-input" placeholder="e.g., 02119, 02120, 02121 (comma-separated)" value={formData.zip_codes?.join(', ')} onChange={(e) => onArrayInput('zip_codes', e.target.value)} className="rounded-xl mt-1.5" />
      </div>
      <div>
        <Label>Languages Offered</Label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2">
          {LANGUAGES.map(lang => (
            <div key={lang} className="flex items-center space-x-2">
              <Checkbox id={`lang-${lang}`} data-testid={`language-${lang}`} checked={formData.languages_offered?.includes(lang)} onCheckedChange={(checked) => onMultiSelect('languages_offered', lang, checked)} />
              <label htmlFor={`lang-${lang}`} className="text-sm text-[#5A5A5A]">{lang}</label>
            </div>
          ))}
        </div>
      </div>
      <div>
        <Label>Physical Address</Label>
        <Input data-testid="address-input" placeholder="e.g., 780 Albany Street, Boston, MA 02118" value={formData.physical_address} onChange={(e) => onChange('physical_address', e.target.value)} className="rounded-xl mt-1.5" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <Label>Phone Number</Label>
          <Input data-testid="phone-input" placeholder="e.g., (617) 555-1234" value={formData.phone_number} onChange={(e) => onChange('phone_number', e.target.value)} className="rounded-xl mt-1.5" />
        </div>
        <div>
          <Label>Website</Label>
          <Input data-testid="website-input" placeholder="e.g., https://example.org" value={formData.website} onChange={(e) => onChange('website', e.target.value)} className="rounded-xl mt-1.5" />
        </div>
      </div>
      <div>
        <Label>Hours</Label>
        <Input data-testid="hours-input" placeholder="e.g., Mon-Fri 9am-5pm" value={formData.hours || ''} onChange={(e) => onChange('hours', e.target.value)} className="rounded-xl mt-1.5" />
      </div>
    </CardContent>
  </Card>
);

export default LocationSection;
